import { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";

import UserService from "src/Services/API/user.service";
import AssignRow from "./assignrow";
import { handleError } from "src/Common/function";

const AssignTechModal = ({ shown, onCancelClicked, onSaveClicked, assignedTechs, branch }) => {
  const [userArray, setUserArray] = useState([]);
  const [techArray, setTechArray] = useState([{ user: -1, roleId: -1 }]);
  // const [assignedTechnicians, setAssignedTechnicians] = useState(assignedTechs);

  useEffect(() => {
    let temp = [];
    for (let item of assignedTechs) {
      temp.push({ user: item.user.id, roleId: item.roleId });
    }
    setTechArray(temp);
  }, [assignedTechs]);

  useEffect(() => {
    if (assignedTechs.length === 0) {
      setTechArray([{ user: -1, roleId: -1 }]);
    }

    if (!shown) return;

    UserService.getUsersByRole("Technician", branch)
      .then((response) => {
        if (response.status == 200) {
          let techs = response.data.filter((user) => user.isEnabled === true);
          UserService.getUsersByRole("Manager", branch)
            .then((res) => {
              if (res.status == 200) {
                let managers = res.data.filter((user) => user.isEnabled === true);
                setUserArray([...techs, ...managers].sort((a, b) => a.name.localeCompare(b.name)));
              }
            })
            .catch((error) => handleError(error));
        }
      })
      .catch((error) => handleError(error));

    // UserService.getAll()
    //   .then((response) => {
    //     console.log(response);
    //     if (response.status == 200) {
    //       console.log(response.data);
    //       setUserArray(response.data);
    //     }
    //   })
    //   .catch((error) => {
    //     toast(error.response.data.message);
    //     console.log("User List Fetching Error: ", error);
    //   });
  }, [shown]);

  const techSelected = (user, index) => {
    // persist the chosen user's id; fallback to -1 if cleared
    const temp = [...techArray];
    temp[index].user = user?.id ?? -1;
    setTechArray(temp);
  };

  const roleSelected = (roleIndex, index) => {
    let temp = [...techArray];
    temp[index].roleId = roleIndex;
    setTechArray(temp);
  };

  const addMore = () => {
    console.log("...techArray: ", ...techArray);
    setTechArray([...techArray, { user: -1, roleId: -1 }]);
  };

  const removeTech = (index) => {
    let temp = [...techArray];
    temp.splice(index, 1);
    setTechArray(temp);
  };

  const selectedUserIds = techArray.map((item) => item.user).filter((id) => id !== -1);
  const isSaveDisabled = techArray.some((item) => item.user !== -1 && item.roleId === -1);

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30">
        <OutsideClickHandler
          onOutsideClick={() => {
            onCancelClicked();
          }}
        >
          <div className="w-[550px] px-5 py-5 bg-white rounded-[6px]">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5">Assign</p>

            <div className="flex ">
              <p className="w-[50%] text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-5">Team:</p>
              <p className="w-[50%] text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-5">Role:</p>
            </div>
            <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
              {techArray.map((item, index) => {
                // hide users that are already selected in other rows, but keep the current one visible
                const availableUsers = userArray.filter(
                  (user) => user.id === item.user || !selectedUserIds.includes(user.id)
                );

                return (
                  <AssignRow
                    userArray={availableUsers}
                    onUserSelected={techSelected}
                    onRoleSelected={roleSelected}
                    index={index}
                    tech={item}
                    key={index}
                    remove={removeTech}
                  />
                );
              })}
            </div>
            <p onClick={addMore} className="font-OpenSansBold text-subTitleColor text-[12px] mt-2 cursor-pointer">
              + Add more
            </p>

            <div className="w-full flex justify-between gap-3 mt-5">
              <div
                onClick={onCancelClicked}
                className="cursor-pointer w-[50%] h-[30px] rounded-[6px] flex items-center justify-center font-OpenSansRegular font-[600] text-[10px] text-inputFieldTextColor border-borderColor border-[1px]"
              >
                CANCEL
              </div>

              <div
                onClick={() => {
                  if (isSaveDisabled) return;
                  onSaveClicked(techArray);
                }}
                className={`w-[50%] h-[30px] rounded-[6px] flex items-center justify-center font-OpenSansRegular font-[600] text-[10px] text-white ${
                  isSaveDisabled ? "bg-blueColor opacity-50 cursor-not-allowed" : "bg-blueColor cursor-pointer"
                }`}
              >
                SAVE
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
};

export default AssignTechModal;
